import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";
import "katex/dist/katex.min.css";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { concreteSplice } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteSplice({}) {
  const toast = useToast();
  // BAR GRIP
  const [spliceInputs, setSpliceInputs] = useState({
    fck: 20,
    fyk: 500,
    bar_type: "Tracionada",
    grip: "Boa aderência",
    spliced_bars: ">50%",
    diameter: 6.3,
    as_cal: "",
    as_ef: "",
  });
  const [spliceOutputs, setSpliceOutputs] = useState({
    fbd: "",
    lb_nec: "",
    l0t: "",
    l0t_min: "",
    memorial: {},
  });

  function updateSpliceInputs(name, value) {
    if (
      value === "" ||
      name === "bar_type" ||
      name === "grip" ||
      name === "spliced_bars"
    ) {
      if (value === "Tracionada")
        setSpliceInputs((prevInputs) => ({
          ...prevInputs,
          spliced_bars: ">50%",
        }));
      else if (value === "Comprimida") {
        setSpliceInputs((prevInputs) => ({
          ...prevInputs,
          spliced_bars: "",
        }));
      }
      setSpliceInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setSpliceInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setSpliceOutputs({
      fbd: "",
      lb: "",
      lb_nec: "",
      lb_min: "",
    });
  }

  function onSpliceCalculate() {
    if (spliceInputs["as_cal"] === "" || spliceInputs["as_ef"] === "") {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (spliceInputs["as_cal"] === 0 || spliceInputs["as_ef"] === 0) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else if (spliceInputs["as_ef"] < spliceInputs["as_cal"]) {
      toast({
        title: "A área de aço adotada deve ser maior que a de cálculo",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteSplice(spliceInputs).then((response) => {
        setSpliceOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-splice-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "concrete-splice-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Traspasse:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateSpliceInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500]}
              unit="MPa"
              onChange={(e) => updateSpliceInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Barra"
              elements={["Tracionada", "Comprimida"]}
              unit=""
              onChange={(e) => updateSpliceInputs("bar_type", e.target.value)}
            />
            <Select
              text="Zona"
              elements={["Boa aderência", "Má aderência"]}
              unit=""
              onChange={(e) => updateSpliceInputs("grip", e.target.value)}
            />
          </div>
          {spliceInputs["bar_type"] === "Tracionada" && (
            <div className={styles.inputRow}>
              <Select
                text="Barras emend. na seção"
                elements={["≤20%", "25%", "33%", "50%", ">50%"]}
                unit=""
                onChange={(e) =>
                  updateSpliceInputs("spliced_bars", e.target.value)
                }
                value={spliceInputs["spliced_bars"]}
              />
            </div>
          )}
          <div className={styles.inputRow}>
            <Select
              text="Ø"
              elements={[6.3, 8, 10, 12.5, 16, 20, 25, 32]}
              unit="mm"
              onChange={(e) => updateSpliceInputs("diameter", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="As,cal"
              unit="cm²"
              onChange={(e) => updateSpliceInputs("as_cal", e.target.value)}
            />
            <InputNumber
              text="As,ef"
              unit="cm²"
              onChange={(e) => updateSpliceInputs("as_ef", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onSpliceCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output text="fbd" value={spliceOutputs["fbd"]} unit="kN/cm²" />
          <Output text="Lb,nec" value={spliceOutputs["lb_nec"]} unit="cm" />
          <div className={styles.outputRow}>
            <Output text="L0t" value={spliceOutputs["l0t"]} unit="cm" />
            {`(${Math.ceil(spliceOutputs["l0t"] / (spliceInputs["diameter"] / 10))}Ø)`}
          </div>
          <Output text="L0t,min" value={spliceOutputs["l0t_min"]} unit="cm" />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {spliceOutputs["memorial"] &&
          Object.entries(spliceOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteSplice;
